import { h2sSublayers } from '../../helper';

// get ids layer
export const getLayerIds = (pType: string, pOption?: string) => {

  let ids: number[] = [];
  if (pType === 'do') {
    ids = [101, 106];
  } else if (pType === 'pr') {
    ids = [102, 105];
  } else if (pType === 'h2s') {
    ids = [h2sSublayers()[0]];
  } else if (pType === 'ecp') {
    ids = [107];
  } else if (pType === 'indus') {
    ids = [80];
  } else if (pType === 'hydro') {
    ids = [301, 302, 306];
  } else if (pType === 'pluie') {
    ids = [111, 110];
  } else {
    // milieu
    ids = pOption === 'sensibility' ? [108] : [109];
  }
  return ids;
};

// hide or show legend by click button
export const displayLegend = (pValue: string) => {
  let display;
  if (pValue === 'none') {
    display = 'block';
  } else {
    display = 'none';
  }
  return display;
};
